import React from 'react';
import '../styles/CorporatePage.css';

const CorporatePage = () => {
  return (
    <div className="corporate-page">
      <div className="page-header">
        <div className="container">
          <h1>Kurumsal</h1>
        </div>
      </div>
      
      <section className="about-section">
        <div className="container">
          <div className="section-title">
            <h2>Hakkımızda</h2>
          </div>
          
          <div className="about-content">
            <div className="about-text">
              <p>
                <strong>PHG Danışmanlık & Müşavirlik</strong> olarak, kendi alanında uzman, tecrübeli 
                çalışma arkadaşlarımızın yanına genç ve dinamik çalışanlar ekleyerek 
                oluşturduğumuz kadromuzla her geçen gün büyümeye devam edip size en 
                güvenilir hizmeti vermekteyiz.
              </p>
              <p>
                Almanya başta olmak üzere Dünya'nın önde gelen bütün ülkelerinde 
                yeni bir gelecek inşa etmenize, başarılarınıza yenilerini eklemenize 
                ve kariyerinizi zirveye taşımanıza destek olmaktayız.
              </p>
              <p>
                Yenilik, Güven ve Şeffaflık ilkelerini benimseyerek profesyonel bir 
                şekilde çıktığımız bu yolda ülkemizdeki ve yurtdışındaki işbitirici 
                bağlantılarımızla şimdiye kadar yola çıktığımız bütün müşterilerimizi 
                memnun ettik.
              </p>
              <p>
              <strong>İstisna Akdi Anlaşması</strong> ve süreç içinde değişebilen / yenilenebilen Türkiye Cumhuriyeti yasal prosedürleri 
              güncel olarak takibimizde olup, Almanya’da faaliyet gösteren Türk yapı inşaat firmalarının tüm resmî kurumlardaki 
              işlemlerini hızlı ve güvenilir bir biçimde yapıyor, takip edilmesi gereken bilgi ve belge akışını deneyimli personellerimiz 
              tarafından profesyonel olarak yürütülüyor.Türkiye’den Almanya’ya götürülen işçilerin, başvuru sürecinden işe başlama dönemine 
              ve işin bitiş zamanına kadar tüm resmi süreçlerini başarılı bir biçimde takip edip, işçilerin tam zamanında Almanya’da sahada olmalarını sağlıyoruz.
              </p>
            </div>
          </div>
        </div>
      </section>
      
      <section className="values-section">
        <div className="container">
          <div className="section-title">
            <h2>Değerlerimiz</h2>
          </div>
          
          <div className="values-grid">
            <div className="value-card">
              <div className="value-icon">🔄</div>
              <h3>Yenilik</h3>
              <p>Sürekli gelişim ve yenilik ile müşterilerimize en güncel ve etkili çözümleri sunuyoruz.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">🤝</div>
              <h3>Güven</h3>
              <p>Müşterilerimizle dürüst ve şeffaf ilişkiler kurarak güven inşa ediyoruz.</p>
            </div>
            
            <div className="value-card">
              <div className="value-icon">🔍</div>
              <h3>Şeffaflık</h3>
              <p>Tüm süreçlerimizde açık ve net iletişim ile şeffaflığı ön planda tutuyoruz.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CorporatePage;